export const init = () => {
    const categories = document.querySelectorAll('.popular-categories__item')

    categories.forEach((category) => {
        // @ts-ignore
        category.addEventListener('mouseover', hoverHandler)
    })
}

const hoverHandler = (e: MouseEvent) => {
    const img = document.querySelector('.popular-categories__preview')
    const preview = ((e.target as HTMLElement).closest('.popular-categories__item') as HTMLElement).dataset.src

    if (!preview) {
        return
    }

    img?.setAttribute('src', preview)
}